module.exports = __webpack_public_path__ + "static/2.3_Gametree_4_NO-ca37d222a49a39a4d953eb72b954be63.svg";